import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const PurpleTickIcon = (props) => {
  const { width = 48, height = 48 } = props;
  return (
    <SVGUniqueID>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx={24} cy={24} r={24} fill="#212329" />
        <path
          d="M23.9998 39.8332C32.7443 39.8332 39.8332 32.7443 39.8332 23.9998C39.8332 15.2553 32.7443 8.1665 23.9998 8.1665C15.2553 8.1665 8.1665 15.2553 8.1665 23.9998C8.1665 32.7443 15.2553 39.8332 23.9998 39.8332Z"
          fill={props.fill}
        />
        <path
          d="M21.7518 29.6684C21.4351 29.6684 21.1343 29.5417 20.9126 29.32L16.4318 24.8392C15.9726 24.38 15.9726 23.62 16.4318 23.1609C16.8909 22.7017 17.6509 22.7017 18.1101 23.1609L21.7518 26.8025L29.8901 18.6642C30.3493 18.205 31.1093 18.205 31.5684 18.6642C32.0276 19.1234 32.0276 19.8834 31.5684 20.3425L22.5909 29.32C22.3693 29.5417 22.0684 29.6684 21.7518 29.6684Z"
          fill="white"
        />
      </svg>
    </SVGUniqueID>
  );
};

PurpleTickIcon.defaultProps = {
  fill: '#8A5AD5'
};

export { PurpleTickIcon };
